import React, { type FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ApolloProvider } from '@apollo/client';

import { client } from '@admin/libraries/apollo';

import { Player as AudioPlayer } from './audio/player';
import { FlashMessageCenter } from './flash_messages/center';
import { NavBar } from './layout/nav_bar';
import { Router } from './router';

export const App: FC = () => (
  <ApolloProvider client={client}>
    <BrowserRouter>
      <div id="container" className="effect mainnav-out navbar-fixed">
        <NavBar />

        <div className="boxed">
          <div id="content-container">
            <div id="page-alert">
              <FlashMessageCenter />
            </div>

            <div id="page-content">
              <Router />
            </div>

            <AudioPlayer />
          </div>
        </div>

        <footer id="footer">
          <p className="text-center">© Clutter</p>
        </footer>
      </div>
    </BrowserRouter>
  </ApolloProvider>
);
